import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/i18n";

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("agoo_lang") || "fr");
  useEffect(() => { localStorage.setItem("agoo_lang", lang); }, [lang]);
  const t = (key) => translations[lang][key] || translations.fr[key] || key;
  const toggle = () => setLang((l) => (l === "fr" ? "en" : "fr"));
  return <LangContext.Provider value={{ lang, setLang, toggle, t }}>{children}</LangContext.Provider>;
}
